module.exports = __webpack_public_path__ + "img/amrei_11_done_3.e1adffe5.jpeg";